import { JsonObject, JsonProperty } from "json2typescript";
import { DrugTripletInteractionResult } from "domain/entities/drug-triplet-interaction/structures/DrugTripletInteractionResult";

@JsonObject("InteractionSearchTResult")
export class InteractionSearchTResult {
    @JsonProperty("drug_interactions_triplet", [DrugTripletInteractionResult])
    drugTripletInteractions?: DrugTripletInteractionResult[];
}